import { render, staticRenderFns } from "./LicenseShow.vue?vue&type=template&id=13d7cd1c&scoped=true&"
import script from "./LicenseShow.vue?vue&type=script&lang=js&"
export * from "./LicenseShow.vue?vue&type=script&lang=js&"
import style0 from "./LicenseShow.vue?vue&type=style&index=0&id=13d7cd1c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d7cd1c",
  null
  
)

export default component.exports